<section class="default-section">
  <article class="default-card">
    <div class="card page-jumbotron-card">
      <div class="page-jumbotron">
        <div class="page-jumbotron-image">
          <picture>
            @for (width of trumpImageWidths; track $index) {
              <source [srcset]="imgPath + '/start/trump-post-alert-w' + width + '.webp'" media="(min-width: {{ width }}px)" />
            }
            <img [src]="trumpFallbackImage" alt="Trump Post Alert" class="jumbotron-image no-scale-crop" />
          </picture>
        </div>

        <div class="page-jumbotron-content">
          <h1 class="jumbotron-headline">Trump Post Alert</h1>
          <p class="jumbotron-lead">{{ LEAD_TRUMP_POST_ALERT }}</p>
          <a href="https://trumppostalert.com" target="_blank" rel="noreferrer">
            <button mat-flat-button color="primary">Zu TrumpPostAlert.com</button>
          </a>
        </div>
      </div>
    </div>

    <h1 class="paragraph-headline">Was ist Trump Post Alert?</h1>

    <p>
      Trump Post Alert informiert Anleger in Echtzeit über die möglichen
      <span class="highlight-text">Marktauswirkungen der Posts von Donald Trump auf Truth Social</span>. Jede Meldung wird automatisch von
      KI analysiert und als sofortige Push-Nachricht oder E-Mail-Vorschau ausgeliefert, damit Investoren und Analysten entscheidungsfähig
      bleiben.
    </p>

    <div class="row">
      <div class="col-md-6">
        <h2 class="paragraph-headline-2">Schnelle, verlässliche Einordnung</h2>
        <ul>
          <li>
            <h3 class="paragraph-headline-3">Sekundenschnelle Alerts</h3>
            <p>
              Alerts werden ausgelöst, sobald ein neuer <span class="highlight-text">relevanter</span> Truth-Social-Post erscheint –
              inklusive kompakter Risikoeinschätzung.
            </p>
          </li>
          <li>
            <h3 class="paragraph-headline-3">Relevanz-Scoring</h3>
            <p>Jeder Post wird anhand seiner potenziellen Markt- und Geopolitik-Wirkung bewertet, damit Prioritäten sofort klar sind.</p>
          </li>
          <li>
            <h3 class="paragraph-headline-3">Ticker & Historie</h3>
            <p>Im Web-Frontend stehen ein Live-Ticker und eine filterbare Historie der letzten Meldungen bereit.</p>
          </li>
        </ul>
      </div>
      <div class="col-md-6">
        <h2 class="paragraph-headline-2">Highlights der Plattform</h2>
        <ul>
          <li>
            <h3 class="paragraph-headline-3">Intelligente Automatisierung</h3>
            <p>
              <span class="highlight-text">KI-basierte Auswertung</span> kombiniert Signalsprache, Sentiment und Themencluster zu
              verwertbaren Erkenntnissen für Portfoliomanager.
            </p>
          </li>
          <li>
            <h3 class="paragraph-headline-3">Multi-Channel-Auslieferung</h3>
            <p>Benachrichtigungen können via Web-App oder E-Mail ausgeliefert werden.</p>
          </li>
          <li>
            <h3 class="paragraph-headline-3">Alles aus einer Hand</h3>
            <p>
              Architektur, Frontend in Angular 20, Backend in Kotlin sowie die gesamte Infrastruktur auf Google Cloud Platform wurden
              inhouse entwickelt.
            </p>
          </li>
        </ul>
      </div>
    </div>

    <h2 class="paragraph-headline-2">Für wen eignet sich der Dienst?</h2>
    <p>
      Trump Post Alert richtet sich an Vermögensverwalter, Fintech-Teams, Research-Abteilungen und alle, die politische Statements in
      Echtzeit beobachten müssen. Die Plattform hilft dabei, Chancen und Risiken frühzeitig zu erkennen und interne Entscheidungsprozesse zu
      beschleunigen.
    </p>
  </article>
</section>
